import type { TerminEinstellungen } from '../types';

// Brand-Violet als Hex (nicht var(--ld-primary)), da BLUE vielfach per
// String-Konkat mit Alpha-Suffix genutzt wird (z.B. BLUE + '40', `${BLUE}50`).
export const BLUE = '#6B5FD4';

export const ART_LABEL: Record<string, string> = {
  KA: 'Klassenarbeit', Test: 'Test / Quiz', Muendlich: 'Mündlich', Sonstiges: 'Sonstiges',
};
export const ART_FARBE: Record<string, string> = {
  KA: '#7C5CBF', Test: '#0891B2', Muendlich: '#059669', Sonstiges: '#8A5E0E',
};

export const DEFAULT_TERMIN_EINST: TerminEinstellungen = {
  vorOrt:      { aktiv: true,  wochentage: [1, 2, 3, 4], bisUhrzeit: '17:00' },
  telefonisch: { aktiv: true,  wochentage: [5],           bisUhrzeit: '15:00' },
  termindauer: 20,
  puffer:      15,
  fruehestens: '07:30',
  spaetestens: '18:00',
};
